import { gql } from '@parkchirp/api-client';

export const LIST_PERMISSION_FUNCTION_GROUPS_V2 = gql`
    query listPermissionFunctionGroups(
        $limit: Int!,
        $offset: Int!,
        $filters: [Filter],
        $order: SortOrder,
    ) {
        listPermissionFunctionGroups(
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
        ) {
            count,
            functionGroups {
                id, 
                name,
                description,
                domain,
            }
        }
    }
`;
